import { ListData } from "../../app/store/reducers/appSlice"

export const prepareFilterQuery = (filter?: any) => {
  const values = {
    ...filter,
    category: getIdsFromDropdownValue(filter.category),
  }

  const query: any = {}
  query.nameFull = values.name ? [{"operator": "%like%", "value": filter.name}] : undefined
  query.country_id = values.country ? [{"operator": "=", "value": values.country}] : undefined
  query.stend = values.stend ? [{"operator": "%like%", "value": values.stend}] : undefined
  query.categoryId = values.category ? [{"operator": "in", "value": values.category}] : undefined
  query.activityId = values.activity ? [{ "operator": "in", "value": values.activity }] : undefined
  query.seo = values.seo ? [{ "operator": "%like%", "value": values.seo }] : undefined
console.log([query, 'query'])
  return {
    filter: query
  }
}

export const getIdsFromDropdownValue = (value?: Array<ListData>) => {
  if (value && value.length) {
    return value.map(item => item.value)
  }
}
